import React from 'react'
import TrashIcon from '../../../../../components/Icon/Trash'
import { VisibilityRoundedIcon } from '../../../../../components/Icon/VisibilityRoundedIcon'
import ArrowDownloadIcon from '../../../../../components/Icon/ArrowDownload'

export const menuOpcoesPopper = ({ data, functions }) => {


  const handleCallCurrentFunction = (functionName) => {
    if (functionName) {
      functionName(data)
      functions.closePopper()
    }
  };

  const isManuallySigned = data.situacao === 'ManuallySigned'

  const optionsMenu = [
    {
      id: 'pac-doc-btn-vis',
      ativo: !isManuallySigned,
      icon: <VisibilityRoundedIcon size='20' color='#505050' />,
      label: 'Visualizar',
      onClick: () => handleCallCurrentFunction(functions?.handleClickVisualizar),
    },
    {
      id: 'pac-doc-btn-bai',
      ativo: data.urlDownload? true: false,
      icon: <ArrowDownloadIcon size='24' color='#505050' />,
      label: 'Baixar',
      onClick: () => handleCallCurrentFunction(functions?.handleClickBaixar),
    },
    {
      id: 'pac-doc-btn-can',
      ativo:  !isManuallySigned,
      icon: <TrashIcon size='20' color='#505050' />,
      label: 'cancelar',
      onClick: () => handleCallCurrentFunction(functions?.handleClickCancelar),
    },
    {
      id: 'pac-doc-btn-ori',
      ativo:!isManuallySigned,
      icon: <ArrowDownloadIcon size='20' color='#505050' />,
      label: 'Baixar original',
      onClick: () => handleCallCurrentFunction(functions?.handleClickImprimirOriginal),
    },
    {
      id: 'pac-doc-btn-ass',
      ativo: data?.idExternoAssinadoPlugsign && !isManuallySigned,
      icon: <ArrowDownloadIcon size='20' color='#505050' />,
      label: 'Baixar assinado',
      onClick: () => handleCallCurrentFunction(functions?.handleClickImprimirAssinado),
    },
    {
      id: 'pac-doc-btn-man',
      ativo: isManuallySigned,
      icon: <ArrowDownloadIcon size='20' color='#505050' />,
      label: 'Baixar',
      onClick: () => handleCallCurrentFunction(functions?.handleClickImprimirAssinadoManualmente),
    },
  ]
  return optionsMenu
}